import entryFactory from 'bpmn-js-properties-panel/lib/factory/EntryFactory'

import cmdHelper from 'bpmn-js-properties-panel/lib/helper/CmdHelper'
import store from '@/store'
import axios from 'axios'

export default function(element, bpmnFactory, options, translate) {
  let SearchFormString = ''
  let PageSize = 10
  let FormList = []
  let SearchWorkflowString = ''

  async function fillForms() {
    let urlParams = `?page=1&size=${PageSize}&sort=changedAt,desc&active=true`
    if (SearchFormString && SearchFormString !== '') {
      urlParams = urlParams + '&search=' + SearchFormString
    }
    let response = await axios.get(`/api/v1/honeyForms${urlParams}`)
    if (response.data._embedded) {
      FormList = response.data._embedded.honeyForms
    } else {
      FormList = []
    }
  }

  let pageSize = entryFactory.selectBox({
    id: 'pageSize',
    label: 'Please select the page size',
    selectOptions: [
      { value: 10, name: '10' },
      { value: 20, name: '20' },
      { value: 50, name: '50' }
    ],
    modelProperty: 'pageSize',
    get: function(element, values, node) {
      pageSize = PageSize
      return {
        pageSize: pageSize,
        label: 'Please select the page size'
      }
    },

    set: function(element, values, node) {
      PageSize = values.pageSize
      fillForms()
    }
  })

  let searchForms = entryFactory.textField({
    id: 'searchForms',
    label: 'Search Forms by name or description',
    modelProperty: 'searchForms',

    get: function(element, values, node) {
      searchForms = SearchFormString
      return {
        searchForms: searchForms,
        label: 'Search Forms by name or description'
      }
    },

    set: function(element, values, node) {
      SearchFormString = values.searchForms
      fillForms()
    }
  })

  let selectForm = entryFactory.selectBox({
    id: 'formKey',
    label: 'Please select the user form',
    selectOptions: function(element, node) {
      let forms = []
      forms.push({ value: undefined, name: 'Select an user form' })
      FormList.forEach(form => {
        forms.push({
          value: form.formKey,
          name: form.description || form.formKey
        })
      })

      let bo = element.businessObject
      let form = bo.get('formKey')
      if (form != null && form !== '') {
        forms.push({ value: form, name: form })
      }
      return forms
    },
    modelProperty: 'formKey',
    emptyParameter: false,
    set: function(element, values, node) {
      let bo = element.businessObject
      let prop = {}
      prop['formKey'] = values.formKey
      let entry = store.getters.getHoneyForms.filter(
        form => form.formKey === values.formKey
      )
      if (entry.length > 0) {
        prop['assignee'] = entry[0].assignee
        prop['candidateUsers'] = entry[0].candidateUsers
        prop['candidateGroups'] = entry[0].candidateGroups
      }
      return cmdHelper.updateBusinessObject(element, bo, prop)
    },

    get: function(element, node) {
      let bo = element.businessObject
      selectForm = bo.get('formKey')
      return {
        formKey: selectForm,
        label: 'Please select the user form'
      }
    }
  })

  return [pageSize, searchForms, selectForm]
}
